import { SUB_PRODUCT_TYPE } from './components/PostManagement/configs'
export const LINK_API = process.env.REACT_APP_API_URL
export const LINK_API_IMAGE = `${LINK_API}/api/v1/upload`
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const phoneRegex = /^(?:\+84|0)(?:\d){9}$/
export const cccdRegex = /^\d{12}$/ // CCCD gồm 12 chữ số
export const passportRegex = /^[A-Z]{1}\d{7}$/ // HC gồm 1 chữ cái + 7 số
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/ // Định dạng mật khẩu

export const removeUndefinedValues = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value !== undefined)
  )
}
export const createSubProductType = (selectionList = []) => ({
  APARTMENT: selectionList
    .filter((i) => i.category === 'APARTMENT_BDS')
    .map((i) => ({ value: i.value, label: i.title })),

  BUILDING: selectionList
    .filter((i) => i.category === 'BUILDING_BDS')
    .map((i) => ({ value: i.value, label: i.title })),

  REAL_ESTATE: selectionList
    .filter((i) => i.category === 'REAL_ESTATE_BDS')
    .map((i) => ({ value: i.value, label: i.title })),

  GROUND: selectionList
    .filter((i) => i.category === 'GROUND_BDS')
    .map((i) => ({ value: i.value, label: i.title }))
})
export const getLabelByValue = (value, selectionList) => {
  // Case 1: Có selectionList → build động + ép value về string

  if (Array.isArray(selectionList) && selectionList.length > 0) {
    const source = createSubProductType(selectionList)
    const stringValue = String(value)

    for (const key in source) {
      const item = source[key]?.find((n) => String(n.value) === stringValue)

      if (item) return item.label
    }

    return ''
  }

  // Case 2: Không có selectionList → dùng SUB_PRODUCT_TYPE cứng
  for (const key in SUB_PRODUCT_TYPE) {
    const item = SUB_PRODUCT_TYPE[key]?.find(
      (n) => n.value == value // giữ nguyên behavior cũ
    )
    if (item) return item.label
  }

  return ''
}
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('vi-VN', { style: 'decimal' }).format(value)
}

export const removeNullUndefined = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, v]) => v !== null && v !== undefined && v !== ''
    )
  )
}

export const convertPriceToNumber = (priceString = '') => {
  return Number(priceString.replace(/[\.,]/g, ''))
}

export const formatCurrencyUnit = (value) => {
  if (!value) return '0 đồng'

  if (value >= 1_000_000_000) {
    return `${(value / 1_000_000_000).toLocaleString('vi-VN')} tỷ`
  } else if (value >= 1_000_000) {
    return `${(value / 1_000_000).toLocaleString('vi-VN')} triệu`
  } else if (value >= 1_000) {
    return `${(value / 1_000).toLocaleString('vi-VN')} nghìn`
  } else {
    return `${value.toLocaleString('vi-VN')} đồng`
  }
}

// render: (text) => {
//   if (text === 'APPROVED') {
//     return <Tag color="green">Đã duyệt</Tag>
//   } else if (text === 'WAITING') {
//     return <Tag color="yellow">Chờ duyệt</Tag>
//   } else if (text === 'REJECTED') {
//     return <Tag color="red">Từ chối</Tag>
//   } else if (text === 'EDITING') {
//     return <Tag color="red">Đã chỉnh sửa</Tag>
//   }
// }

export const hasPermission = (required, userPermissions) => {
  const user_role = localStorage.getItem('user_role')
  if (user_role === 'ADMIN') {
    return true
  }
  if (Array.isArray(required)) {
    return required.some((perm) => userPermissions.includes(perm))
  }
  return userPermissions.includes(required)
}
export const formatCurrencyLabel = (value) => {
  const num = Number(value)
  if (isNaN(num)) return ''

  if (num >= 1_000_000_000) {
    const ty = num / 1_000_000_000

    // làm tròn tối đa 3 số thập phân, không dư số 0
    const formatted = parseFloat(ty.toFixed(3)).toString().replace('.', '.')

    return `${formatted} Tỷ`
  }

  if (num >= 1_000_000) {
    const trieu = num / 1_000_000
    const formatted = parseFloat(trieu.toFixed(3)).toString().replace('.', '.')
    return `${formatted} Triệu`
  }

  if (num >= 1_000) {
    const nghin = num / 1_000
    const formatted = parseFloat(nghin.toFixed(3)).toString().replace('.', '.')
    return `${formatted} Nghìn`
  }

  return `${num} Đồng`
}

export function removeVietnameseTones(str) {
  return str
    .normalize('NFD') // Tách chữ cái và dấu ra
    .replace(/[\u0300-\u036f]/g, '') // Xóa dấu
    .replace(/đ/g, 'd') // Đổi đ -> d
    .replace(/Đ/g, 'D') // Đổi Đ -> D
    .replace(/\s+/g, ' ') // Bỏ khoảng trắng thừa
    .trim()
}
